import { all } from 'redux-saga/effects'
import { deliverySaga } from './deliverySaga'
import { addressSaga } from './addressSaga'
import { couponSaga } from './couponSaga'
import { mallSaga } from './mallSaga'
import { integralSaga } from './integralSaga'

function * rootSaga () {
  yield addressSaga()
  yield couponSaga()
  yield integralSaga()
  yield all(deliverySaga())
  yield all(mallSaga())
}

export default rootSaga
